export function determineUpdatedAt(updatedAt: string) {
    const d = new Date(updatedAt);
    if (d) {
        const st = d.toUTCString();
        return st.slice(0, st.length - 3);
    }
    return updatedAt;
}
